import React from 'react';
import { OptionComponent } from './../../../../components';

class QuestionComponent extends React.Component {

    render() {
        const { data, checkedAnswers, qNo, passages, isSelect } = this.props;
        return (
            <div className='my-2 d-flex flex-column' >
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    
                }}>
                    <div dangerouslySetInnerHTML={{ __html: data?.question }} 
                        style={{
                            width: '100%', 
                            display: 'flex',
                            overflow: 'auto',
                            textAlign:'left',
                            fontSize: 18, 
                            color: '#000', 
                            fontWeight: 'bold', 
                            flexWrap: 'wrap' 
                               }}>
                    </div>

                </div>
                    <div className='my-2'>
                        <OptionComponent
                            id={data?.id}
                            value={1}
                            option={data?.option1}
                            checkedAnswers={checkedAnswers}
                            isSelect={isSelect}

                        />
                    </div>
                    <div className='my-2'>
                        <OptionComponent
                            id={data?.id}
                            value={2}
                            option={data?.option2}
                            checkedAnswers={checkedAnswers}
                           

                        />
                    </div>
                    <div className='my-2'>
                        <OptionComponent
                            checkedAnswers={checkedAnswers}
                            id={data?.id}
                            value={3}
                            option={data?.option3}
                            


                        />
                    </div>
                    <div className='my-2'>
                        <OptionComponent
                            checkedAnswers={checkedAnswers}
                            id={data?.id}
                            value={4}
                            option={data?.option4}
                          


                        />
                    </div>
            </div>
        )
    }
}

export default QuestionComponent;